import { Injectable } from '@angular/core';

import {Observable} from 'rxjs/Observable';
	
@Injectable()
export class Globals {	
	//Local
	// dataUrl='http://10.211.55.3/bumerang/'; 
	// dataUrl='http://localhost/bumerang/'; 
	
 	//Test
 	// dataUrl='https://tumbleweed.azurewebsites.net/';

 	//Prod
 	dataUrl='https://cashimiro-prod.azurewebsites.net/'; 	

 	// dataUrl='https://bumerang-api-prod.azurewebsites.net/'; 	

 	
 	//Storage account path	
 	sa = 'https://tanrewardssa.blob.core.windows.net';

 	fileUrl = this.sa + '/uploadedfiles/';

 	iconUrl=  this.sa + '/icons/';

 	pwaUrl='http://www.getbumerang.com/app';

 	oneSignalAppId='826c1fb8-7146-45ed-bf78-c9af154985a0'

 	loginData={
 		access_token: ""
 	};
 	currentRole="";
 	messageId="";

 	whiskeyId=6;

 	registeredAsBusiness= false;

 	productCategories: any = [
 		{
 			Id: 1,
 			Label: "Cannabis",
 			Image: "cannabis.png",
 			IsSelected: false
 		},
 		{
 			Id: 2,
 			Label: "Concentrates",
 			Image: "honey.png",
 			IsSelected: false
 		}, 		
 		{
 			Id: 3,
 			Label: "Deals",
 			Image: "buy.png",
 			IsSelected: false
 		},
 		{
 			Id: 4,
 			Label: "Edibles",
 			Image: "gummy-bear.png",
 			IsSelected: false
 		},
 		{
 			Id: 5,
 			Label: "Event",
 			Image: "tickets.png",
 			IsSelected: false
 		}, 		 
 		{
 			Id: 6,
 			Label: "CBD",
 			Image: "skin-oil.png",
 			IsSelected: false
 		}, 		
 		{
 			Id: 7,
 			Label: "Smoking",
 			Image: "cigarette.png",
 			IsSelected: false
 		}, 	
 		{
 			Id: 8,
 			Label: "Storage",
 			Image: "treasure.png",
 			IsSelected: false
 		}, 	 		 				 		
 		{
 			Id: 9,
 			Label: "Topicals",
 			Image: "sunscreen.png",
 			IsSelected: false
 		}, 	 		
 	]

 	businessCategories: any = [
 		{
 			Id: 1,
 			Label: "Groomers",
 			Image: "brush.png",
 			IsSelected: false
 		},
 		{
 			Id: 2,
 			Label: "Hotels",
 			Image: "dog-house.png",
 			IsSelected: false
 		}, 		
 		{
 			Id: 3,
 			Label: "Trainers",
 			Image: "medal.png",
 			IsSelected: false
 		},
 		{
 			Id: 4,
 			Label: "Walkers",
 			Image: "dog-leads.png",
 			IsSelected: false
 		},
 		{
 			Id: 5,
 			Label: "Vets",
 			Image: "veterinarian.png",
 			IsSelected: false
 		},
 		{
 			Id: 6,
 			Label: "Accessories",
 			Image: "collar.png",
 			IsSelected: false
 		},
 		{
 			Id: 7,
 			Label: "Treats",
 			Image: "snack.png",
 			IsSelected: false
 		}			
 	]

 	paymentTypes: any = []
}
	


// WEBPACK FOOTER //
// ./src/providers/globals.ts